<template>
    <div class="rate-requests-layout">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'RateRequestsLayout',
}
</script>
